import React, { useEffect, useState } from "react";
import NewHeader from "../../components/New Header/NewHeader";
import Header from "../../components/Header in Page/_Header";
import Saldo from "../../components/Saldo/_saldo";
import Filter from "./_filter";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { DateTime } from "luxon";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from '@mui/material/Skeleton';
import Item from "./_item";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { setData } from "../../features/movimentiSlice";
import axios from "axios";
import md5 from "md5";
import './_movimenti.scss'
import MovimentoDettaglio from "./_movimentoDettaglio";

function MovimentiNew() {
  const dispatch = useDispatch()
  const customerId = useSelector((user) => user.user.info.customer_id);
  const tkn = md5(customerId + "oYmAIdtki%lu");
  const customerCode = useSelector((user) => user.user.info.customer_code);
  const [month, setMonth] = useState(DateTime.now().toFormat("MM"));
  const [filterActive, setFilterActive] = useState(false);
  const [tag, setTag] = useState("tutti");
  const [year, setYear] = useState(DateTime.now().toFormat("y"));
  const data = useSelector((user) => user.movimenti.data);
  const [more, setMore] = useState(3);
  const [overlay, setOverlay] = useState(false);
  const [details, setDetails] = useState(null);


  useEffect(() => {
    document.body.style.overflow ="hidden";
    document.body.style.touchAction = "none";
    init();
  }, []);

  const init = async () => {
    const apiMovimenti = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getMovimentazioni.php?customer_id=${customerId}&customer_code=${customerCode}&tkn_pvt=${tkn}`;
    await axios.get(apiMovimenti).then(({ data }) => {
      const result = data.result.reverse();
      dispatch(setData(result));
    });
  };

  return (
    <div className="movimenti">
      <div className="movimenti-top">
        {/* header  */}
        <NewHeader setOverlay={setOverlay} logo="white" padding="no" iconsColor="white" overlay={overlay} overlayTitle="Movimenti" />
      </div>
      {!overlay ? (  
        <div className="movimenti-bottom">
          <Header
            title="Movimenti"
            description={`In questa sezione puoi visualizzare tutte le voci presenti all'interno
          del tuo saldo MyRevoluce. In questo modo tieni sotto controllo
          ogni singola voce di spesa.`}
          />
          <Saldo />
          <div className="filtering">
            <div className="date">
              <ArrowBackIosIcon
                onClick={() =>
                  setMonth(
                    DateTime.fromFormat(month, "MM")
                      .plus({ month: -1 })
                      .toFormat("MM")
                  )
                }
              />
              <p className="main">
                {DateTime.fromFormat(month, "MM").toFormat("MMMM")}
              </p>
              <ArrowForwardIosIcon
                onClick={() =>
                  month === DateTime.now().toFormat("MM")
                    ? null
                    : setMonth(
                        DateTime.fromFormat(month, "MM")
                          .plus({ month: +1 })
                          .toFormat("MM")
                      )
                }
              />
            </div>
            <Filter
              setFilterActive={setFilterActive}
              filterActive={filterActive}
              setTag={setTag}
              tag={tag}
              setYear={setYear}
              year={year}
              tags={
                data &&
                data.map((r) => r.tag).filter((e, i, a) => a.indexOf(e) === i)
              }
            />
          </div>
          <div className="movimenti-body">
            {/* {data !== null && tag === 'tutti' ?
                      data.slice(0, 5)
                          .map((r, i) => (
                              <Item data={r} key={i} />
                          )) :
                      data.slice(0, 2)
                          .map((r, i) => (
                              <Item data={r} key={i} />
                          ))
                  } */}
            {data === null ? (
              <>
                <div className="skeleton">
                  <Skeleton variant="circular" width={40} height={40} />
                  <Skeleton variant="rectangular" width={"100%"} height={60} />
                </div>
                <div className="skeleton">
                  <Skeleton variant="circular" width={40} height={40} />
                  <Skeleton variant="rectangular" width={"100%"} height={60} />
                </div>
                <div className="skeleton">
                  <Skeleton variant="circular" width={40} height={40} />
                  <Skeleton variant="rectangular" width={"100%"} height={60} />
                </div>
              </>
            ) : tag === "tutti" ? (
              data
                .filter((d) => d.data_emissione.includes(`${year}-${month}`))
                .slice(0, more)
                .map((r, i) => (
                  <Item
                    data={r}
                    key={i}
                    setOverlay={setOverlay}
                    overlay={overlay}
                    setDetails={setDetails}
                  />
                ))
            ) : (
              data
                .filter(
                  (d) =>
                    tag === d.tag && d.data_emissione.includes(`${year}-${month}`)
                )
                .slice(0, more)
                .map((r, i) => (
                  <Item
                    data={r}
                    key={i}
                    setOverlay={setOverlay}
                    overlay={overlay}
                    setDetails={setDetails}
                  />
                ))
            )}
            {data &&
            data.filter((d) => d.data_emissione.includes(`${year}-${month}`))
              .length >= more ? (
              <div className="more">
                <p onClick={() => setMore(more + 2)}>Mostra di più </p>
                <ArrowDropDown />
              </div>
            ) : (
              <div className="more">
                <p>Niente da visualizzare</p>
              </div>
            )}
          </div>
          <div className="empty"></div>
        </div>
      ) : (
        <div className="movimenti-bottom">
          <MovimentoDettaglio details={details} />
          <div className="empty"></div>
        </div>
      )}
    </div>
  );
}

export default MovimentiNew;
